/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";

export const ContractRowSkeleton = (props) => (
    <ContentLoader
        width={"100%"}
        height={80}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{borderTop: SkeletonSettings.BORDER}}
        {...props}>

        {/* Contract number */}
        <rect x="0" y={`calc(50% - 5px)`} rx="3" ry="3" width="20%" height="10"/>

        {/* Remaining quantity */}
        <rect x={`calc(25% + 10px)`} y={`calc(50% - 5px)`} rx="3" ry="3" width="20%" height="10"/>

        {/* Valid from - until */}
        <rect x={`calc(50% + 20px)`} y={`calc(50% - 5px)`} rx="3" ry="3" width="20%" height="10"/>

        {/* View more */}
        <rect x={"85%"} y={`calc(50% - 20px)`} rx="3" ry="3" width="15%" height="40"/>

    </ContentLoader>
)
